var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.activeItem)?_c('loader'):[_c('header',[_c('h1',{staticClass:"alpha heavy"},[_vm._v("Edit User")])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"sections"},[_c('div',{staticClass:"section--floating section--full"},[_c('user-form',{attrs:{"user":_vm.activeItem,"cta":"Update User","method":"patch"}})],1)])])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }